import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const plansManagement = createApi({
    reducerPath: "plansManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        plansList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/plans`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewPlans: builder.mutation({
            query: (planId) => ({
                url: `v1/${locale}/settings/plans/${planId}`,
                method: "GET",
            }),
        }),

        addPlans: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/plans`,
                method: "POST",
                body: body,
            }),
        }),

        updatePlans: builder.mutation({
            query: ({ body, planId }) => ({
                url: `v1/${locale}/settings/plans/${planId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deletePlans: builder.mutation({
            query: (planId) => ({
                url: `v1/${locale}/settings/plans/${planId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { usePlansListMutation, useDeletePlansMutation, useAddPlansMutation, useViewPlansMutation, useUpdatePlansMutation } = plansManagement;
